import { SkyText } from "@skypointcloud/skypoint-ui";
import { Link } from "wouter";
import { ROUTES, absolutePath } from "@/lib/routes";

/**
 * General's pointer to the rules (B-51b). The rules, their counts and their recipients are
 * edited and shown only on the Notifications tab, so General no longer repeats them; it says
 * where they are. Only the Teams webhook stays on General.
 */
export function NotificationRulesSummary() {
  return (
    <div data-testid="settings-notifications-summary">
      <SkyText size={300}>
        Alert rules are set on the{" "}
        <Link
          href={absolutePath(ROUTES.settingsNotifications)}
          className="font-medium underline underline-offset-2"
          data-testid="settings-manage-rules"
        >
          Notifications tab
        </Link>
        .
      </SkyText>
    </div>
  );
}
